export default __webpack_public_path__ + "static/media/Goalkeeper.cb4bc557.svg";